import { Text, Input, FormControl, Checkbox, VStack } from 'components/ui';
import { Flex } from '@chakra-ui/react';
import { Link } from '../ui/Link';

export const PhoneNumberForm = ({
  agreed,
  label = 'Mobile number',
  phoneNumber,
  setAgreed,
  setPhoneNumber,
}: {
  agreed: boolean;
  label?: string;
  phoneNumber: string;
  setAgreed: (value: boolean) => void;
  setPhoneNumber: (value: string) => void;
}) => {
  const formatPhoneNumber = (text: string) => {
    const cleaned = text.replace(/\D/g, '');

    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

    if (match) {
      const formattedNumber = `${match[1]}${match[2] ? '-' : ''}${match[2]}${
        match[3] ? '-' : ''
      }${match[3]}`;
      return formattedNumber;
    }

    return text;
  };

  return (
    <VStack gap={2}>
      <FormControl>
        <FormControl.Label>{label}</FormControl.Label>

        <Input
          maxW={'100%'}
          placeholder="XXX-XXX-XXXX"
          type="text"
          maxLength={12}
          value={phoneNumber}
          onChange={(e) => {
            const formattedText = formatPhoneNumber(e.target.value);
            setPhoneNumber(formattedText);
          }}
        />
      </FormControl>

      <Flex direction="row" align="flex-start" gap="10px">
        <Checkbox
          bg="white"
          borderColor="#9FB0B8"
          borderWidth="1.5px"
          rounded="5px"
          boxSize="19px"
          mt="1px"
          flexShrink={0}
          _checked={{
            backgroundColor: 'secondary.200',
            borderColor: 'secondary.200',
          }}
          isChecked={agreed}
          onChange={() => setAgreed(!agreed)}
        />

        {/* The phone screen overrides the shared checkbox copy style with
                a smaller Blue Grey variant. */}
        <Text
          color="blueGray.600"
          fontSize="11.5px"
          lineHeight="1.45"
          letterSpacing="0.01em"
          textAlign="left"
          flex={1}
        >
          By providing my phone number, I consent to receive calls and text
          messages from Ayble Health and its service providers regarding my
          account, eligibility, appointment scheduling, care plans, and related
          healthcare services. These communications may include calls using
          automated technology or artificial or AI-generated voices. I may opt
          out of receiving these communications at any time by replying STOP to
          text messages or requesting that calls stop. Message frequency varies.
          Message and data rates may apply. Consent is not a condition of
          receiving services. For more information, please refer to the Ayble
          Health{' '}
          <Link
            color="aqua.500"
            fontWeight={600}
            textDecoration="none"
            href="https://www.ayblehealth.com/privacy-policy"
            isExternal
          >
            Privacy Policy
          </Link>{' '}
          and{' '}
          <Link
            color="aqua.500"
            fontWeight={600}
            textDecoration="none"
            href="https://www.ayblehealth.com/terms-of-service"
            isExternal
          >
            Terms of Service
          </Link>
          .
        </Text>
      </Flex>
    </VStack>
  );
};

export default PhoneNumberForm;
